import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';

import { HomePage } from './pages/HomePage/Loadable';
import { NotFoundPage } from './pages/NotFoundPage/Loadable';
import { makeStyles } from '@material-ui/core/styles';

import { ConfigParamHomePage } from './pages/configParam/admin/ConfigParamHomePage';
import { UpdateConfigParamPage } from './pages/configParam/admin/UpdateConfigParamPage/Loadable';
import { AddConfigParamPage } from './pages/configParam/admin/AddConfigParamPage/Loadable';
import { ConfigParamDashBoardPage } from './pages/configParam/admin/ConfigParamDashBoardPage';

import { AddUserPage } from './pages/user/admin/AddUserPage/Loadable';
import { UserEmailVerifyPage } from './pages/user/UserEmailVerifyPage/Loadable';
import { SignInPage } from './pages/user/SignInPage/Loadable';
import { ProfileUpdatePage } from './pages/user/ProfileUpdatePage/Loadable';
import { ChangePasswordPage } from './pages/user/ChangePasswordPage/Loadable';
import { PasswordResetRequestPage } from './pages/user/PasswordResetRequestPage/Loadable';
import { PasswordResetPage } from './pages/user/PasswordResetPage/Loadable';

import { NotificationAdminHomePage } from './pages/notification/admin/NotificationAdminHomePage';
import { AuditAdminHomePage } from './pages/audit/admin/AuditAdminHomePage';
//import { CreditRequestPage } from './pages/credit/request/CreditRequestPage/Loadable';

import { UserAdminHomePage } from './pages/user/admin/UserAdminHomePage/Loadable';
import { UserAdminUpdatePage } from './pages/user/admin/UserAdminUpdatePage/Loadable';

import { DocumentPage } from './pages/library/DocumentPage/Loadable';
import { EditDocumentPage } from './pages/library/DocumentPage/EditLoadable';
import { PersonDocumentsPage } from './pages/library/PersonDocumentsPage/LoadableByIdentificationDocument';
import { PersonDocumentsPage as StageDocumenstPage } from './pages/library/PersonDocumentsPage/LoadableByStage';
import { PersonDocumentsPage as LegalProcessActionDocumenstPage } from './pages/library/PersonDocumentsPage/LoadableByLegalProcessAction';
import { PersonDocumentsPage as DocumentIdPage } from './pages/library/PersonDocumentsPage/LoadableByDocumentId';

import { ConciliationRequestMatterPage } from './pages/conciliation/request/matter/MatterLoadable';
import { ConciliationRequestAssessmentPage } from './pages/conciliation/request/assessment/AssessmentLoadable';
import { ConciliationRequestDetailsPage } from './pages/conciliation/request/details/DetailsLoadable';
import { ConciliationRequestApprovalPage } from './pages/conciliation/request/approval/ApprovalLoadable';
import { ConciliationRequestViewPage } from './pages/conciliation/request/view/ViewLoadable';
import { ConciliationRequestViewForConvenedPage } from './pages/conciliation/request/view/ViewForConvenedLoadable';

import { ConciliationRequestAdminPage } from './pages/conciliation/request/admin/RequestAdminHomePage/Loadable';
import { PublishResultsPage } from './pages/conciliation/request/publishResults/PublishResultsLoadable';

import { UserSessionExtention } from './pages/library/UserSessionExtention/Loadable';

import { useTranslation } from 'react-i18next';
import { withTranslation } from 'react-i18next';
import { config } from 'config';
import { AppDrawer } from './components/AppDrawer';
import { CssBaseline, Hidden } from '@material-ui/core';
import { configClientParams } from 'services/config/admin/ConfigParam';
import { appConfig } from 'config/app';
import { ReportPage } from './pages/ethicalInbox/complaint/report/ReportLoadable';
import { ResponsePage } from './pages/ethicalInbox/complaint/response/ResponseLoadable';
import { OutResponsePage } from './pages/ethicalInbox/complaint/response/OutResponseLoadable';
import { EthicalInboxAdminHomePage } from './pages/ethicalInbox/complaint/admin/ComplaintAdminHomePage/Loadable';
import { FSJPAppTopBar } from './components/AppBar/FSJP-index';
import { AppTopBar } from './components/AppBar';
import RouteChangeHandler from './routeChangeHandler';

configClientParams();

const HomePageI18n = withTranslation()(HomePage);
const NotFoundPageI18n = withTranslation()(NotFoundPage);

const ConfigParamHomePageI18n = withTranslation()(ConfigParamHomePage);
const UpdateParamPageI18n = withTranslation()(UpdateConfigParamPage);
const AddConfigParamPageI18n = withTranslation()(AddConfigParamPage);
const ConfigParamDashBoardPageI18n = withTranslation()(
  ConfigParamDashBoardPage,
);

const NotificationAdminHomePageI18n = withTranslation()(
  NotificationAdminHomePage,
);
const AuditAdminHomePageI18n = withTranslation()(AuditAdminHomePage);

const UserAdminHomePageI18n = withTranslation()(UserAdminHomePage);
const UserAdminUpdatePageI18n = withTranslation()(UserAdminUpdatePage);

const DocumentPageI18n = withTranslation()(DocumentPage);
const EditDocumentPageI18n = withTranslation()(EditDocumentPage);

const ReportPageI18n = withTranslation()(ReportPage);

const PersonDocumentsPageI18n = withTranslation()(PersonDocumentsPage);
const StageDocumentsPageI18n = withTranslation()(StageDocumenstPage);
const LegalProcessActionDocumentsPageI18n = withTranslation()(
  LegalProcessActionDocumenstPage,
);
const DocumentIdPageI18n = withTranslation()(DocumentIdPage);

const ConciliationRequestMatterPageI18n = withTranslation()(
  ConciliationRequestMatterPage,
);
const ConciliationRequestAssessmentPageI18n = withTranslation()(
  ConciliationRequestAssessmentPage,
);
const ConciliationRequestDetailsPageI18n = withTranslation()(
  ConciliationRequestDetailsPage,
);
const ConciliationRequestApprovalPageI18n = withTranslation()(
  ConciliationRequestApprovalPage,
);
const ConciliationRequestViewPageI18n = withTranslation()(
  ConciliationRequestViewPage,
);

const ConciliationRequestViewForConvenedPageI18n = withTranslation()(
  ConciliationRequestViewForConvenedPage,
);

const PublishResultsPageI18n = withTranslation()(PublishResultsPage);

const ConciliationRequestAdminHomePageI18n = withTranslation()(
  ConciliationRequestAdminPage,
);

const EthicalInboxAdminHomePageI18n = withTranslation()(
  EthicalInboxAdminHomePage,
);

const ResponsePageI18n = withTranslation()(ResponsePage);

const OutResponsePageI18n = withTranslation()(OutResponsePage);

const UserSessionExtentionI18n = withTranslation()(UserSessionExtention);

const AddUserPageI18n = withTranslation()(AddUserPage);
const UserEmailVerifyPageI18n = withTranslation()(UserEmailVerifyPage);
const SignInPageI18n = withTranslation()(SignInPage);
const ChangePasswordPageI18n = withTranslation()(ChangePasswordPage);
const PasswordResetPageI18n = withTranslation()(PasswordResetPage);
const PasswordResetRequestPageI18n = withTranslation()(
  PasswordResetRequestPage,
);
const ProfileUpdatePageI18n = withTranslation()(ProfileUpdatePage);

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  container: {
    width: '100%',
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  icon: {
    width: 'auto',
    height: '16px',
  },
  bottomInfo: {
    borderRight: '1px solid #ebebeb',
    paddingRight: '20px',
    paddingLeft: '20px',
    padding: '11px 20px 9px 20px',
    width: 'auto',
    margin: '0px 0 0px 0px',
    '& a': {
      color: theme.palette.primary.dark,
      textDecoration: 'none',
    },
    '& svg': {
      color: theme.palette.primary.dark,
      textDecoration: 'none',
    },
  },
}));

function Copyright() {
  return (
    <>
      <Typography variant="body2" color="textSecondary" align="center">
        {'Copyright © '}
        <Link color="inherit" href={config.appURL}>
          {config.companyName}
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}
      </Typography>
    </>
  );
}

export function App() {
  const { i18n } = useTranslation();
  const classes = useStyles();
  const [fsjpLocation, setFsjpLocation] = React.useState(false);

  //console.log('Starting in appURI: ' + config.appURI);

  const patternToCheck = '/ethicalInbox';

  return (
    <BrowserRouter basename={config.appURI}>
      <RouteChangeHandler
        patternToCheck={patternToCheck}
        setFsjpLocation={setFsjpLocation}
      />
      <Helmet
        titleTemplate="%s"
        defaultTitle={config.companyName}
        htmlAttributes={{ lang: i18n.language }}
      >
        <meta name="description" content={config.companyName} />
      </Helmet>
      <main className={classes.root}>
        <CssBaseline />
        {fsjpLocation ? <FSJPAppTopBar /> : <AppTopBar />}

        <Hidden xsDown implementation="css">
          <AppDrawer variant="persistent" />
        </Hidden>
        <Hidden smUp>
          <AppDrawer variant="temporary" />
        </Hidden>
        <div className={classes.container}>
          <Routes>
            <Route path={'/'} element={<HomePageI18n />} />
            <Route
              path={
                appConfig.react_routes.prefix +
                appConfig.react_routes.modules.ethicalInbox.prefix +
                appConfig.react_routes.modules.ethicalInbox.services.new
              }
              element={<ReportPageI18n />}
            />
            <Route
              path={
                appConfig.react_routes.prefix +
                appConfig.react_routes.modules.ethicalInbox.prefix +
                appConfig.react_routes.modules.ethicalInbox.services.view
              }
              element={<OutResponsePageI18n />}
            />
            <Route
              path={
                appConfig.react_routes.prefix +
                appConfig.react_routes.modules.ethicalInbox.prefix +
                appConfig.react_routes.modules.ethicalInbox.services.response
              }
              element={<ResponsePageI18n />}
            />
            <Route
              path={
                config.react_routes.prefix +
                config.react_routes.modules.config.prefix +
                config.react_routes.modules.config.services.home
              }
              element={<ConfigParamHomePageI18n />}
            />
            <Route
              path={
                config.react_routes.prefix +
                config.react_routes.modules.config.prefix +
                config.react_routes.modules.config.services.addParam
              }
              element={<AddConfigParamPageI18n />}
            />
            <Route
              path={
                config.react_routes.prefix +
                config.react_routes.modules.config.prefix +
                config.react_routes.modules.config.services.editParam
              }
              element={<UpdateParamPageI18n />}
            />
            <Route
              path={
                config.react_routes.prefix +
                config.react_routes.modules.config.prefix +
                config.react_routes.modules.config.services.friendly
              }
              element={<ConfigParamDashBoardPageI18n />}
            />
            <Route
              path={
                config.react_routes.prefix +
                config.react_routes.modules.notification.prefix +
                config.react_routes.modules.notification.services.home
              }
              element={<NotificationAdminHomePageI18n />}
            />
            <Route
              path={
                config.react_routes.prefix +
                config.react_routes.modules.audit.prefix +
                config.react_routes.modules.audit.services.home
              }
              element={<AuditAdminHomePageI18n />}
            />
            <Route
              path={
                config.react_routes.prefix +
                config.react_routes.modules.user.prefix +
                config.react_routes.modules.user.services.signin
              }
              element={<SignInPageI18n />}
            />
            <Route
              path={
                config.react_routes.prefix +
                config.react_routes.modules.user.prefix +
                config.react_routes.modules.user.services.profileUpdate
              }
              element={<ProfileUpdatePageI18n />}
            />
            <Route
              path={
                config.react_routes.prefix +
                config.react_routes.modules.user.prefix +
                config.react_routes.modules.user.services.passwordResetRequest
              }
              element={<PasswordResetRequestPageI18n />}
            />
            <Route
              path={
                config.react_routes.prefix +
                config.react_routes.modules.user.prefix +
                config.react_routes.modules.user.services.passwordReset
              }
              element={<PasswordResetPageI18n />}
            />
            <Route
              path={
                config.react_routes.prefix +
                config.react_routes.modules.user.prefix +
                config.react_routes.modules.user.services.changePassword
              }
              element={<ChangePasswordPageI18n />}
            />
            <Route
              path={
                config.react_routes.prefix +
                config.react_routes.modules.userAdmin.prefix +
                config.react_routes.modules.userAdmin.services.home
              }
              element={<UserAdminHomePageI18n />}
            />
            <Route
              path={
                config.react_routes.prefix +
                config.react_routes.modules.userAdmin.prefix +
                config.react_routes.modules.userAdmin.services.add
              }
              element={<AddUserPageI18n />}
            />
            <Route
              path={
                config.react_routes.prefix +
                config.react_routes.modules.user.prefix +
                config.react_routes.modules.user.services.emailVerify
              }
              element={<UserEmailVerifyPageI18n />}
            />
            <Route
              path={
                config.react_routes.prefix +
                config.react_routes.modules.userAdmin.prefix +
                config.react_routes.modules.userAdmin.services.edit
              }
              element={<UserAdminUpdatePageI18n />}
            />
            <Route
              path={
                appConfig.react_routes.prefix +
                appConfig.react_routes.modules.documents.prefix +
                appConfig.react_routes.modules.documents.services.newDocument
              }
              element={<DocumentPageI18n />}
            />
            <Route
              path={
                appConfig.react_routes.prefix +
                appConfig.react_routes.modules.conciliation.prefix +
                appConfig.react_routes.modules.conciliation.services
                  .viabilityQuery
              }
              element={<ConciliationRequestMatterPageI18n />}
            />
            <Route
              path={
                appConfig.react_routes.prefix +
                appConfig.react_routes.modules.conciliationAdmin.prefix +
                appConfig.react_routes.modules.conciliationAdmin.services
                  .assessment
              }
              element={<ConciliationRequestAssessmentPageI18n />}
            />
            <Route
              path={
                appConfig.react_routes.prefix +
                appConfig.react_routes.modules.conciliation.prefix +
                appConfig.react_routes.modules.conciliation.services
                  .conciliationRequest
              }
              element={<ConciliationRequestDetailsPageI18n />}
            />
            <Route
              path={
                appConfig.react_routes.prefix +
                appConfig.react_routes.modules.conciliationAdmin.prefix +
                appConfig.react_routes.modules.conciliationAdmin.services
                  .approval
              }
              element={<ConciliationRequestApprovalPageI18n />}
            />
            <Route
              path={
                appConfig.react_routes.prefix +
                appConfig.react_routes.modules.conciliationAdmin.prefix +
                appConfig.react_routes.modules.conciliationAdmin.services
                  .publishResults
              }
              element={<PublishResultsPageI18n />}
            />
            <Route
              path={
                appConfig.react_routes.prefix +
                appConfig.react_routes.modules.conciliation.prefix +
                appConfig.react_routes.modules.conciliation.services.view
              }
              element={<ConciliationRequestViewPageI18n />}
            />
            <Route
              path={
                appConfig.react_routes.prefix +
                appConfig.react_routes.modules.conciliation.prefix +
                appConfig.react_routes.modules.conciliation.services
                  .viewForConvened
              }
              element={<ConciliationRequestViewForConvenedPageI18n />}
            />
            <Route
              path={
                appConfig.react_routes.prefix +
                appConfig.react_routes.modules.conciliationAdmin.prefix +
                appConfig.react_routes.modules.conciliationAdmin.services.home
              }
              element={<ConciliationRequestAdminHomePageI18n />}
            />
            <Route
              path={
                appConfig.react_routes.prefix +
                appConfig.react_routes.modules.ethicalInboxAdmin.prefix +
                appConfig.react_routes.modules.ethicalInboxAdmin.services.home
              }
              element={<EthicalInboxAdminHomePageI18n />}
            />
            <Route
              path={
                appConfig.react_routes.prefix +
                appConfig.react_routes.modules.ethicalInboxAdmin.prefix +
                appConfig.react_routes.modules.ethicalInboxAdmin.services.edit
              }
              element={<ResponsePageI18n />}
            />

            <Route
              path={
                appConfig.react_routes.prefix +
                appConfig.react_routes.modules.documents.prefix +
                appConfig.react_routes.modules.documents.services.documentEdit
              }
              element={<EditDocumentPageI18n />}
            />
            <Route
              path={
                appConfig.react_routes.prefix +
                appConfig.react_routes.modules.documents.prefix +
                appConfig.react_routes.modules.documents.services
                  .personDocuments
              }
              element={<PersonDocumentsPageI18n />}
            />
            <Route
              path={
                appConfig.react_routes.prefix +
                appConfig.react_routes.modules.documents.prefix +
                appConfig.react_routes.modules.documents.services.stageDocuments
              }
              element={<StageDocumentsPageI18n />}
            />
            <Route
              path={
                appConfig.react_routes.prefix +
                appConfig.react_routes.modules.documents.prefix +
                appConfig.react_routes.modules.documents.services
                  .legalProcessActionDocuments
              }
              element={<LegalProcessActionDocumentsPageI18n />}
            />
            <Route
              path={
                appConfig.react_routes.prefix +
                appConfig.react_routes.modules.documents.prefix +
                appConfig.react_routes.modules.documents.services.documentView
              }
              element={<DocumentIdPageI18n />}
            />
            <Route
              path={
                appConfig.react_routes.prefix +
                appConfig.react_routes.modules.documents.prefix +
                appConfig.react_routes.modules.documents.services
                  .userSessionExtention
              }
              element={<UserSessionExtentionI18n />}
            />
            <Route path="*" element={<NotFoundPageI18n />} />
          </Routes>
          <Box mt={8}>
            <Copyright />
          </Box>
        </div>
      </main>
    </BrowserRouter>
  );
}
